import type { AuthTokens } from '@utility-nyc/react-query-sdk';

import { generateEndUserSession } from '@utility-nyc/react-query-sdk';

const isEndUserDevAuthBypassEnabled = () => {
  const { EXPO_PUBLIC_DEV_AUTH_BYPASS } = process.env;

  return EXPO_PUBLIC_DEV_AUTH_BYPASS === 'true';
};

const loginWithEndUserDevAuthBypass = async (
  email: string,
  setTokens: (tokens: AuthTokens) => void,
) => {
  const response = await generateEndUserSession({
    params: { email, ensure: true },
  });

  setTokens(response.data.tokens);
};

export { isEndUserDevAuthBypassEnabled, loginWithEndUserDevAuthBypass };
